export const baseUrl = import.meta.env.VITE_API_URL
